import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "survey-interactions" }
const _hoisted_2 = { class: "survey-interactions__header" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "survey-interactions__row-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "survey-interactions__column-header" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_9 = { class: "survey-interactions__row-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_h1 = _resolveComponent("n-h1")!
  const _component_n_radio = _resolveComponent("n-radio")!
  const _component_n_radio_group = _resolveComponent("n-radio-group")!
  const _component_n_table = _resolveComponent("n-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_n_h1, null, {
        default: _withCtx(() => [
          _createTextVNode("Interactions")
        ]),
        _: 1
      }),
      _createElementVNode("p", null, _toDisplayString(_ctx.text), 1)
    ]),
    _createElementVNode("div", null, [
      (_ctx.tablet)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_n_table, { bordered: true }, {
              default: _withCtx(() => [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yourNetwork, (person, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("th", _hoisted_4, [
                        _createTextVNode(_toDisplayString(`${person.name}, ${person.organization} `) + " ", 1),
                        _hoisted_5,
                        _createElementVNode("div", null, [
                          person
                            ? (_openBlock(), _createBlock(_component_n_radio_group, {
                                key: 0,
                                class: "survey-interactions__device-column",
                                value: person.interactionKey,
                                "onUpdate:value": ($event: any) => ((person.interactionKey) = $event)
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                                    return (_openBlock(), _createBlock(_component_n_radio, {
                                      key: option.key,
                                      value: option.key,
                                      "onUpdate:value": ($event: any) => ((option.key) = $event),
                                      label: option.label
                                    }, null, 8, ["value", "onUpdate:value", "label"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["value", "onUpdate:value"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_n_table, { bordered: true }, {
              default: _withCtx(() => [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_7, [
                    _hoisted_8,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                      return (_openBlock(), _createElementBlock("th", {
                        key: option.key
                      }, _toDisplayString(option.label), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yourNetwork, (person, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("th", _hoisted_9, _toDisplayString(`${person.name.trim().length > 0 ? `${person.name},` : ''} ${person.organization}`), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                        return (_openBlock(), _createElementBlock("td", {
                          class: "survey-interactions__column-checkbox",
                          key: option.key
                        }, [
                          person
                            ? (_openBlock(), _createBlock(_component_n_radio_group, {
                                key: 0,
                                value: person.interactionKey,
                                "onUpdate:value": ($event: any) => ((person.interactionKey) = $event)
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_n_radio, {
                                    value: option.key,
                                    "onUpdate:value": ($event: any) => ((option.key) = $event)
                                  }, null, 8, ["value", "onUpdate:value"])
                                ]),
                                _: 2
                              }, 1032, ["value", "onUpdate:value"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]))
    ])
  ]))
}